import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const DuoUniPelletPlusDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazan pe peleți <span className={styles.highlight}>Duo Uni Pellet Plus</span></p>
      <p className={styles.text}>
        Centrala pe peleți Duo UNI Pellet Plus este prevazut pentru încălzirea locuințelor și unităților industriale în regim automat. Peleții sunt transportați cu ajutorul șnecului din buncăr, care se afla lângă cazan. Combustibilul potrivit pentru cazanul  Duo UNI Pellet Plus se considera peleții care corespund clasei DIN plus.
      </p>
      <h3>
        Caracteristicile peletului recomandat:
      </h3>
      <ul>
        <li>
          Umiditate max 10%
        </li>
        <li>
          Diametru intre 6 și 8 mm
        </li>
        <li>
          Lungime 25-40 mm
        </li>
      </ul>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-info" />
          <p>
            Este posibila exploatarea cazanului în regim de alimentare manuala a combustibilului solid. Pentru trecerea la acest regim este nevoie sa comandați din fabrica următoarele accesorii: ventilator, unitate automatizare, grătare fonta (pentru 21 pana la 50 kW) și ușiță de fonta.
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Grosimea carcasei din otel și a schimbătorului de căldura a cazanului este de 6 mm. Acesta este un indicator important, deoarece viata cazanului depinde direct de acesta.
      </p>
      <p className={styles.text}>
        In complectație de baza a cazanului Duo UNI Pellet Plus este montat este montat arzătorul de peleți de înaltă performanta Eco-Palnik, al producătorului polonez. Este echipat cu funcția de aprindere automata. Peleții sunt alimentați de la buncăr prin șnecul de alimentare la conducta ondulata prin care este alimentat porționat arzătorul, într-o camera de ardere din otel rezistent la căldura. Arzătorul este curățat automat prin mișcarea grătarelor și suflarea turbinelor. Arzătorul este complet automatizat, în toate fazele procesului de ardere -aprindere, ardere, așteptare, stingere se programează. Construcția arzătorului exclude pericolul supraîncălzirii cazanului în absenta alimentarii cu energie electrica, deoarece cantitatea combustibilului pe grătar este suficient de mica. În cazul penelor de curent electric, arzătorul oprește și pornește automat.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus" />
          <p>
            La comanda, pe cazanul Duo UNI Pellet Plus se pot monta și alte arzătoare, ai altor producători.
          </p>
        </div>
      </div>
      <p className={styles.text}>
        Pentru posibilitatea funcționarii cazanului cu combustibil solid în regimul alimentarii manuale a cuptorului (ex- lemn de foc), în complectație cu cazanul se pot comanda set de grătare de fonta, care se vor așeza în acest caz în camera de ardere la nivelul potrivit acestora ,se potrivesc la cazane (intre 21-50 кW).  Duo UNI Pellet/Plus de la 62 la 200 кW, pentru folosirea acestui combustibil solid, va fi necesara umplerea grătarelor cu apa. In plus ,pe peretele superior al corpului cazanului este prevazut un orificiu pentru instalarea ventilatorului (închis cu un capac), care va sufla aerul în camera de ardere.
      </p>
      <p className={styles.text}>
        Duo UNI Pellet Plus are patru camere de ardere a gazelor (schimbătorul de căldura), ce permite utilizarea eficienta a căldurii produse din arderea în boiler. Schimbătorul de căldura utilizează în mod eficient căldura în urma arderii combustibilului și a purtătorului de căldura. Controlerul măsoară permanent temperatura apei, astfel direcționând alimentarea automata a combustibilului. Controlerul este conectat la pompa de circulație a sistemului de încălzire.
      </p>
      <h1 className={styles.title}>Alimentarea cazanului</h1>
      <p className={styles.text}>
        Întreținerea funcționalității cazanului consta în adăugarea periodica a combustibilului în buncăr și îndepărtarea cenușii de pe raftul cenușar al cazanului, fără a fi necesara stingerea acestuia. După aprinderea centralei nu este nevoie de o supraveghere permanenta a acestuia. Funcționalitatea cazanului poate a dura pentru întregul sezon de încălzire fără a fi întrerupta. Centrala de asemenea poate fi folosita și în afara sezonului rece, pentru încălzirea apei, legata în sistem cu un boiler.
      </p>
      <p className={styles.text}>
        Cazanele au gura de evacuare de forma rotunda și au un șubler, cu ajutorul căruia controlam tirajul de evacuare a gazelor arse,pentru economisirea combustibilului.
      </p>
      <p className={styles.text}>
        Achiziționând o centrala Duo UNI Pellet Plus nu numai că veți economisi bani, dar și timp, deoarece acesta nu necesita o supraveghere frecventa.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>21 kW</th>
              <th>27 kW</th>
              <th>33 kW</th>
              <th>40 kW</th>
              <th>50 kW</th>
              <th>62 kW</th>
              <th>75 kW</th>
              <th>95 kW</th>
              <th>120 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>1,9</td>
              <td>2,3</td>
              <td>2,6</td>
              <td>3,1</td>
              <td>3,6</td>
              <td>4,5</td>
              <td>5,0</td>
              <td>6,0</td>
              <td>8,2</td>
              <td>9,3</td>
              <td>10,2</td>
              <td>14,1</td>
              <td>17,4</td>
            </tr>
            <tr>
              <td>Volumul buncărului</td>
              <td>dm³</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>700</td>
              <td>700</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>84</td>
              <td>92</td>
              <td>105</td>
              <td>120</td>
              <td>135</td>
              <td>170</td>
              <td>194</td>
              <td>220</td>
              <td>290</td>
              <td>328</td>
              <td>357</td>
              <td>560</td>
              <td>660</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apă</td>
              <td>kg</td>
              <td>420</td>
              <td>440</td>
              <td>480</td>
              <td>520</td>
              <td>560</td>
              <td>790</td>
              <td>830</td>
              <td>910</td>
              <td>1220</td>
              <td>1310</td>
              <td>1400</td>
              <td>1920</td>
              <td>2350</td>
            </tr>
            <tr>
              <td>Tirajul necesar a gazelor arse</td>
              <td>Pa</td>
              <td colSpan="13">23-30</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="13">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandată</td>
              <td>°C</td>
              <td colSpan="13">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td>°C</td>
              <td colSpan="13">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (maxim)</td>
              <td>mPa</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="15">Consumul de energie electrică, min</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>În proces de exploatare</td>
              <td>W</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
              <td>500</td>
              <td>500</td>
            </tr>
            <tr>
              <td>La aprindere</td>
              <td>W</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>1200</td>
              <td>1200</td>
            </tr>
            <tr>
              <td>Diametrul extern racord coș</td>
              <td>mm</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
              <td>178</td>
              <td>219</td>
              <td>248</td>
              <td>248</td>
              <td>248</td>
              <td>298</td>
              <td>298</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
            </tr>
            <tr>
              <td>Diametru conexiune rețelei de apă</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>65(FL)</td>
              <td>65(FL)</td>
              <td>80(FL)</td>
              <td>80(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Dimensiuni pentru burlan</th>
              <th>U.M.</th>
              <th>201</th>
              <th>201</th>
              <th>248</th>
              <th>248</th>
              <th>377</th>
              <th>452</th>
              <th>452</th>
              <th>452</th>
              <th>660</th>
              <th>660</th>
              <th>660</th>
              <th>908</th>
              <th>1194</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>201</td>
              <td>201</td>
              <td>248</td>
              <td>248</td>
              <td>377</td>
              <td>452</td>
              <td>452</td>
              <td>452</td>
              <td>660</td>
              <td>660</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>160</td>
              <td>160</td>
              <td>180</td>
              <td>180</td>
              <td>220</td>
              <td>250</td>
              <td>250</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
              <td>6</td>
              <td>6</td>
              <td>7</td>
              <td>7</td>
              <td>7</td>
              <td>8</td>
              <td>9</td>
              <td>10</td>
            </tr>
            <tr>
              <td>Diametrul unității pentru siguranță (Du)</td>
              <td>mm</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>20</td>
              <td>20</td>
              <td>20</td>
              <td>25</td>
              <td>25</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const DuoUniPelletPlusDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1300, 1300, 1350, 1350, 1350, 1460, 1460, 1460, 1600, 1600, 1600, 2080, 2280] },
    { param: "B1", unit: "mm", values: [510, 510, 560, 560, 560, 720, 720, 720, 860, 860, 860, 1070, 1270] },
    { param: "H", unit: "mm", values: [1390, 1390, 1440, 1490, 1490, 1850, 1900, 1930, 2110, 2110, 2110, 2350, 2350] },
    { param: "H1", unit: "mm", values: [1325, 1325, 1375, 1425, 1425, 1740, 1790, 1820, 1995, 1995, 1995, 2230, 2230] },
    { param: "H2", unit: "mm", values: [1170, 1170, 1210, 1260, 1240, 1541, 1591, 1616, 1768, 1768, 1768, 1992, 1967] },
    { param: "L", unit: "mm", values: [1220, 1270, 1270, 1340, 1420, 1520, 1570, 1760, 1930, 2060, 2160, 2140, 2300] },
    { param: "L1", unit: "mm", values: [680, 730, 730, 800, 880, 880, 930, 1030, 1100, 1230, 1330, 1490, 1650] },
    { param: "D", unit: "mm", values: [159, 159, 178, 178, 219, 248, 248, 248, 298, 298, 298, 348, 398] }
  ]


  const headers = ["Parametri", "U.M.", "21 kW", "27 kW", "33 kW", "40 kW", "50 kW", "62 kW", "75 kW", "95 kW", "120 kW", "150 kW", "200 kW", "250 kW", "300 kW"]


  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/DuoUniPelletPlusSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};